@if (thumbItem) {
  <img
    [galleryPhoto]="thumbItem.ThumbnailUrl"
    [ngClass]="{ 'no-row-limit': !config?.limitToOneRow }"
    [ngStyle]="{ height: getImgHeight() }"
    class="thumb"
    data-test-id="thumb"
  />
  <loader color="primary" data-test-id="thumb-loader"></loader>
}
